const INITIAL_STATE = {
  loading: false,
  vagas: {
    loading: false,
  },
};

export const Types = {
  SET_VAGAS_LOADING: 'app/vagas/loading',
  SET_VAGAS_LOADING_FiNISHED: 'app/vagas/loading_fineshed',
  SET_LOADING: 'app/loading',
  FINISH_LOADING: 'app/finish-loading',
};

// Actions Creators
export const Actions = {
  setAppLoading: () => ({ type: Types.LOADING }),
  setAppLoadingComplete: () => ({ type: Types.FINISH_LOADING }),
};

// Reducer
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.LOADING:
      return { ...state, loading: true };
    case Types.FINISH_LOADING:
      return { ...state, loading: false };
    case Types.SET_VAGAS_LOADING:
      return { ...state, vagas: { loading: true } };
    case Types.SET_VAGAS_LOADING_FiNISHED:
      return { ...state, vagas: { loading: false } };
    default:
      return state;
  }
};
